import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('validators')
  .extendHookCollectionsFactory('validators')
  .factory()

export {
  Provider as ValidatorProvider,
  useStore as useValidatorStore,
}
